import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'assets/css/main.css';
import 'assets/css/responsivo.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);